import { useCallback, useState, type RefCallback } from 'react';

/** The rendered width of an element, tracked as it resizes, for charts that draw to their container. */
export function useElementWidth<T extends Element>(): readonly [RefCallback<T>, number] {
  const [width, setWidth] = useState(0);
  const ref = useCallback((element: T | null) => {
    if (element === null) {
      return undefined;
    }
    const observer = new ResizeObserver((entries) => {
      setWidth(Math.round(entries[entries.length - 1].contentRect.width));
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
}
